<template>
  <button @click="click" class="button-submit" :class="{'button-submit-success': success}" :disabled="load">
    <Spinner v-if="load" />
    <CheckIcon class="h-5 w-5 mr-2" aria-hidden="true" v-if="success" />
    <slot>
      Speichern
    </slot>
  </button>
</template>

<script setup>
const props = defineProps({load: Boolean, success: {type: Boolean, default: false}});
const emits = defineEmits(['click']);
const click = () => emits('click');
</script>
